import {  WIDGET_LAYOUT_CONFIG } from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    // next:null
};

const reducer = (state=initialState, action)=>{
    switch(action.type){
        case  WIDGET_LAYOUT_CONFIG.REQUEST:
            return {...state, isLoading: true}
        case  WIDGET_LAYOUT_CONFIG.FAILURE:
            return {...state, isLoading:false}
        case  WIDGET_LAYOUT_CONFIG.SUCCESS:     
        return {
            ...state,
            data: action.obj.isLoadMore ? [...state.data,...action.obj.data] : action.obj.data,
            // next: action.obj.next,
            isLoading:false
          };      
        default:
            return state
    }   
}

export default reducer;
